import React from 'react';
import styles from './Toggle.module.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Toggle = ({ active, toggle, text }) => {
  return (
    <button
      className={classNames(styles.toggle, { [styles.active]: active })}
      onClick={toggle}
    >
      <div className={styles.ball}>{text}</div>
    </button>
  );
};

Toggle.propTypes = {
  active: PropTypes.bool,
  toggle: PropTypes.func,
  text: PropTypes.string,
};

Toggle.defaultProps = {
  active: false,
  toggle: null,
  text: null,
};

export default Toggle;
